export function hexToRGBA(hex?: string, opacity: number = 1): string | undefined {
  if (!hex || opacity < 0 || opacity > 1) return
  const cleanHex = hex.replace('#', '')
  const hexMap = cleanHex.match(new RegExp('(.{' + cleanHex.length / 3 + '})', 'g'))
  if (!hexMap || hexMap.length === 0) return
  const rgba = hexMap
    .map((part: string) => {
      return parseInt(cleanHex.length % 2 ? part + part : part, 16)
    })
    .concat(opacity)
    .join(',')
  return `rgba(${rgba})`
}
